import React from "react";
import "./style.css";

const ArticlePreview = ({article}) => {
	return (
    <div className="article-preview">
        {article.preview_image === "" ?
            <img alt="placeholder"
                src="./assets/images/placeholder.svg" draggable={false}/> :
            <img alt="preview of article"
                src={article.preview_image} draggable={false}/>}
        <div className="article-content-wrapper">
            <a href={article.src} target="_blank" rel="noreferrer" draggable={false}>{article.title} </a>
            {"date" in article ? <div className="text-text_gray text-smaller leading-normal py-1">{article.date}</div> : <div className="h-1"/>}
            <div className="article-content">{article.preview_content}</div>
        </div>
    </div>
  );
};
export default ArticlePreview;